module.exports = __webpack_public_path__ + "static/media/06.f0fce114.jpg";